import { LocationContext } from "@freightsimple/generated-dashboard-openapi-client/models/LocationContext";
import { LocationType } from "@freightsimple/generated-dashboard-openapi-client/models/LocationType";
import { getDistributionWareHouseSupportsDeliveryDeadline } from "@/Data/getDistributionWareHouseSupportsDeliveryDeadline";
import type { AddLocationLocationType } from "@/Shared/Types/locationTypes";

// Only the type and brand decide, so a PreBookingShipment's location qualifies
// as well as the address form's — the Review screen re-runs the deadline rule.
export function bookShipmentShouldShowDeadlineSection(
  location: Pick<
    AddLocationLocationType,
    "locationType" | "distributionWarehouseBrand"
  >,
  context: LocationContext,
): boolean {
  if (
    location.locationType === LocationType.DistributionWarehouse &&
    getDistributionWareHouseSupportsDeliveryDeadline(
      location.distributionWarehouseBrand,
    )
  ) {
    return true;
  }

  if (
    location.locationType === LocationType.TradeShow &&
    context === LocationContext.Delivery
  ) {
    return true;
  }

  return false;
}
